import paneheader from "../../../../assets/images/docs/paneheader.png";
import panefooter from "../../../../assets/images/docs/panebottom.png";
import * as React from 'react';
export default {
  paneheader,
  panefooter,
  React
};